import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import AgentDetailModal from './AgentDetailModal';
import AgentCard from './AgentCard';

const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    Filter: 'pull-right form-control',
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}
const PhoneColumn = ({ value }) => <a href={`tel:${value}`}>{value}</a>;

class AgentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false
    };
    this.show = this.show.bind(this);
    this.close = this.close.bind(this);
  }
  close() {
    this.setState({
      showDetail: false,
    });
  }
  show(id) {
    this.setState({
      detail: id,
      showDetail: true,
    });
  }
  findAgent(id) {
    const idx = this.props.agents.findIndex(findById, id);
    if (idx === -1) {
      console.log('that should not happen... findAgent', id);
      return {};
    }
    return this.props.agents[idx];
  }

  render() {
    const agents = [];
    const AvatarColumn = ({ value }) => <Avatar name={value} size={32} src={value} round />;
    const EditorColumn = ({ value }) => (
      <Button
        name="Edit"
        bsStyle="success"
        title="Edit User"
        onClick={value}
      >
        <i className="fa fa-pencil fa-lg" />
      </Button>
    );
    const DeletionColumn = ({ value }) => (
      <Button
        name="Remove"
        bsStyle="danger"
        title="Remove"
        data-item={value}
        onClick={this.removeUser}
      >
        <i className="fa fa-trash-o fa-lg" />
      </Button>
    );

    this.props.agents.forEach((agent) => {
      const photo = agent.profile.custom_image ? agent.profile.custom_image : `${agent.first_name} ${agent.last_name}`;
      agents.push({
        image: photo,
        email: agent.email,
        first_name: agent.first_name,
        id: agent.id,
        last_name: agent.last_name,
        mobile: agent.profile.mobile,
        office: agent.profile.office,
        title: agent.profile.title,
        username: agent.username,
        showAgentDetails: (e) => {
          e.preventDefault();
          this.show(agent.id);
        },
      });
    });
    if (this.props.isExpanded) {
      return (
        <div>
          <AgentCard show={this.show} agents={agents}/>
          { this.state.showDetail && (
            <AgentDetailModal
            agent={this.findAgent(this.state.detail)}
            show={this.show}
            onClose={this.close}
            />
          )}
        </div>
      )
    }
    return (
      <div>
        <Griddle
          data={agents}
          plugins={[plugins.LocalPlugin]}
          styleConfig={styleConfig}
          components={{
            SettingsToggle: () => <span />,
            Pagination: () => <span />,
          }}
        >
          <RowDefinition>
            <ColumnDefinition id="image" order={1} title=" " customComponent={AvatarColumn} />
            <ColumnDefinition id="username" order={2} title="Username" />
            <ColumnDefinition id="email" order={3} title="Email" />
            <ColumnDefinition id="first_name" order={4} title="First Name" />
            <ColumnDefinition id="last_name" order={5} title="Last Name" />
            <ColumnDefinition id="title" order={6} title="Title" />
            <ColumnDefinition id="mobile" order={7} title="Mobile" customComponent={PhoneColumn} />
            <ColumnDefinition id="office" order={8} title="Office" customComponent={PhoneColumn} />
            <ColumnDefinition id="showAgentDetails" order={99} title=" " customComponent={EditorColumn} />
            <ColumnDefinition id="id" order={100} title=" " customComponent={DeletionColumn} />
          </RowDefinition>
        </Griddle>
        { this.state.showDetail && (
          <AgentDetailModal
            agent={this.findAgent(this.state.detail)}
            show={this.show}
            onClose={this.close}
          />
        )}
      </div>
    );
  }
}


AgentTable.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

AgentTable.defaultProps = {
  agents: [],
};
export default AgentTable;



// WEBPACK FOOTER //
// src/routes/agency/components/AgentTable.js